import { getOwnerWindow, isElement } from './dom.js';
import { noop } from './fn.js';

/**
 * Observe a single element for size changes. Returns a cleanup function
 * that disconnects the observer.
 */
function observeResize(el, callback) {
    const resolved = resolveElement(el);
    if (!resolved)
        return noop;
    let first = true;
    const ResizeObserverConstructor = getOwnerWindow(resolved).ResizeObserver ?? ResizeObserver;
    const observer = new ResizeObserverConstructor((entries) => {
        callback(entries[0], observer, first);
        first = false;
    });
    observer.observe(resolved);
    return () => observer.disconnect();
}
/**
 * Observe multiple elements for size changes with a shared observer.
 * Returns a cleanup function that disconnects the observer.
 */
function observeResizeAll(elements, callback) {
    const resolved = resolveElements(elements);
    if (resolved.length === 0)
        return noop;
    const ResizeObserverConstructor = getOwnerWindow(resolved[0]).ResizeObserver ?? ResizeObserver;
    const observer = new ResizeObserverConstructor(callback);
    for (const el of resolved) {
        observer.observe(el);
    }
    return () => observer.disconnect();
}
function resolveElement(input) {
    if (input == null)
        return null;
    if (isElement(input))
        return input;
    return input.current ?? null;
}
function resolveElements(inputs) {
    const elements = [];
    for (const input of inputs) {
        const resolved = resolveElement(input);
        if (resolved)
            elements.push(resolved);
    }
    return elements;
}

export { observeResize, observeResizeAll };
//# sourceMappingURL=observe-resize.js.map
